var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_c('NavBar',{attrs:{"admin":_vm.admin}}),_c('SideBar',{attrs:{"is-condensed":_vm.isMenuCondensed}}),_c('div',{staticClass:"content-page"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }